export const SECURITY_API = `${process.env.DAP_BASE_URI}/wait-times/checkpoint`;
